var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#d7d7d7",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.75 20.25s-.75 3-3.75 3-3.75-3-3.75-3-8.25 1.4895-8.25 9.75h24c0-8.23125-8.25-9.75-8.25-9.75",
    fill: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 24.75c-3.75 0-3.75-4.5-3.75-4.5v-4.5h7.5v4.5s0 4.5-3.75 4.5z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.25 11.25c0 .82875-.67125 1.5-1.5 1.5s-1.5-.67125-1.5-1.5.67125-1.5 1.5-1.5 1.5.67125 1.5 1.5m-13.5 0c0 .82875-.67125 1.5-1.5 1.5s-1.5-.67125-1.5-1.5.67125-1.5 1.5-1.5 1.5.67125 1.5 1.5",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.75 6.75c0-5.72625-13.5-3.72825-13.5 0v5.25c0 3.72825 3.02175 6.75 6.75 6.75s6.75-3.02175 6.75-6.75z",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 0c-4.55625 0-7.5 3.69375-7.5 8.25v1.713l1.5 1.287v-3.75l9-3 3 3v3.75l1.5-1.30575v-1.69425c0-3.01875-.7785-6.01125-4.5-6.75l-.75-1.5z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.25 11.25c0 .414.336.75.75.75s.75-.336.75-.75-.336-.75-.75-.75-.75.336-.75.75m-6 0c0 .414.336.75.75.75s.75-.336.75-.75-.336-.75-.75-.75-.75.336-.75.75",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 24.75c3.75 0 5.05875-2.9475 5.21325-4.071-.86775-.318-1.46325-.429-1.46325-.429s-.75 3-3.75 3-3.75-3-3.75-3-.5955.1095-1.464.4245c.153 1.12125 1.464 4.0755 5.214 4.0755z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.2952204ac1e58a4d130c7123f3b3763c.svg";
export { ForwardRef as ReactComponent };